import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../services/language.service';

@Component({
    selector: 'app-services-ct',
    templateUrl: 'services-ct.component.html',
    styleUrls: ['../pages.scss', 'services-ct.component.scss'],
})

export class ServicesCTComponent {
    activeLanguage = 'german';
    constructor(private ls: LanguageService) {
      ls.getLanguage().subscribe(val => this.activeLanguage = val);
    }
    content = {
        german: `
        <div class="row margin-below">
            <div class="col">
                <h1 class="header">Reinigungstechnologie</h1>
                <h2 class="subheader ">Technologie für saubere Produkte</h2>
            </div>
        </div>
    <div class="row">
         <div class="text-content col-12">
                <p class="start-indent">
                    <span class="highlight">Technologie Consulting Wolke</span> bietet kompetente Beratung zur Fertigung von Produkten
                    mit hohen Sauberkeitsanforderungen und der Fertigung in reiner Umgebung. Unser Leistungsspektrum umfasst:
                </p>
                <ul>
                    <li>Erarbeiten von Fertigungskonzepten in reiner Umgebung, Planung von Medienver- und -entsorgung, sowie Auslegung,
                    Spezifikation und Auswahl
                    geeigneter Produktionsanlagen</li>
                    <li>Punktuelles und linienweites Optimieren der nasschemischen Behandlungsprozesse Reinigen, Ätzen, Beschichten auf
                    Basis der spezifischen Produktanforderungen.</li>
                    <li>Vermitteln von prozesstechnischem Wissen in der Nass- und Trockenreinigung von Fertigungsteilen und
                    Sicherstellung der geforderten Qualität.</li>
                    <li>Gefährdungsanalysen und Risikobeurteilungen gem. DIN EN ISO 14121-1</li>
                    <li>Validierung von Reinigungsprozessen gem. GMP , bzw. FDA 21CFR820 für  medizintechnische und pharmazeutische
                    Produkte.</li>
                    <li>Schulungen und Workshops über den sicheren Umgang mit Chemie in Entwicklungs- und Produktionsumgebungen.</li>
                </ul>
                <p><em>Fragen Sie nach konkreten Projektbeispielen und Referenzen!</em></p>
            </div>
            </div>
            <div class="row">
              <div class="col w-100 image">
              <img src="/assets/cleantechnology.jpg">
              </div>
            </div>`,
      english: `
      <div class="row margin-below">
        <div class="col">
            <h1 class="header">Clean Technology</h1>
            <h2 class="subheader">High tech production in clean environments</h2>
        </div>
      </div>
      <div class="row">
       <div class="text-content col-12">
              <p class="start-indent">
                  <span class="highlight">Technologie Consulting Wolke</span> provides competent support and training on contamination
                  free manufacturing and clean room operation.
              </p>
              <ul>
                  <li>Establish and implement concepts for manufacturing technology in clean environment; planning of media supply and
                   waste treatment; Configuration, specification and selection of suitable production equipment</li>
                  <li>Local or production wide optimization of wet chemical process steps including tool and process improvement,
                   quality assurance based on client specific product requirements</li>
                  <li>Training classes and workshops on knowledge transfer in wet and dry cleaning technology and performance control.</li>
                  <li>Risk and hazard analysis according to SEMI S2 or DIN EN ISO 12100:2010</li>
                  <li>Validation of cleaning processes according to GMP and FDA 21CFR820 standards for
                   medical and pharmaceutical products.</li>
                  <li>Human safety workshops and training on safe handling of chemicals. </li>
              </ul>
              <p><em>Ask for project examples and references</em></p>
          </div>
          </div>
          <div class="row">
            <div class="col w-100 image">
              <img src="/assets/cleantechnology.jpg">
            </div>
          </div>`,
    };
}



// WEBPACK FOOTER //
// ./src/app/components/services-ct/services-ct.component.ts